module.exports = __webpack_public_path__ + "static/img/TOZO_hot.fe04876a.webp";